import React from 'react';
import classes from './Error.module.scss';
import ThinkingEmoji from '../../../images/thinking-emoji.svg';
import CatchHeader from '../CatchHeader/CatchHeader';
import Button from '../../UI/Button/Button';

const Error = (props) => {
    if(props.status === 403)  {
        return (
            <div className={classes.ErrorContainer}>
                <CatchHeader />
                <div className={classes.ErrorImageContainer}>
                    <img src={ThinkingEmoji} alt='thinking-emoji' />
                </div>
                <div className={classes.ErrorTitle}>This page is unavailable</div>
                <div className={classes.ErrorDescription}>
                    <p>
                        Sorry, we are unable to process your request at this time.
                    </p>
                </div>
            </div>
        );        
    } else {
        return (
            <div className={classes.ErrorContainer}>
                <div className={classes.ErrorImageContainer}>
                    <img src={ThinkingEmoji} alt='thinking-emoji' />
                </div>
                <div className={classes.ErrorTitle}>Oops!</div>
                <div className={classes.ErrorDescription}>
                    <p>
                        There was a problem loading this webpage
                    </p>
                    <Button onClick={() => window.location.reload()}
                        btnText="Try Again"
                        className={classes.Button}
                    />
                </div>
            </div>
        );
    }


};

export default Error;